import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="persistent-section"
export default class extends Controller {
	static targets = ["icon", "body"];
	static values = {
		recordId: String,
		name: String,
		open: { type: Boolean, default: true },
	};

	connect() {
		this.loadState();
		// Re-run loadState after Turbo morph
		this.morphHandler = () => this.loadState();
		this.element.addEventListener("turbo:morph-element", this.morphHandler);
	}

	disconnect() {
		this.element.removeEventListener("turbo:morph-element", this.morphHandler);
	}

	toggle(event) {
		if (this.isIgnored(event.target)) return;

		this.openValue = !this.openValue;
		this.saveState();
		this.updateUI();
	}

	loadState() {
		const key = this.storageKey();
		const savedState = localStorage.getItem(key);

		if (savedState !== null) {
			this.openValue = savedState === "true";
		}

		this.updateUI();
	}

	saveState() {
		const key = this.storageKey();
		localStorage.setItem(key, this.openValue.toString());
	}

	updateUI() {
		if (this.openValue) {
			this.open();
		} else {
			this.close();
		}
		for (const toggle of this.element.querySelectorAll('[aria-expanded][data-action*="persistent-section#toggle"]')) {
			toggle.setAttribute("aria-expanded", String(this.openValue));
		}
	}

	open() {
		this.iconTargets.forEach((icon) => {
			icon.classList.add("rotate-90");
		});
		this.bodyTargets.forEach((body) => {
			body.classList.remove("hidden");
		});
		this.openValue = true;
	}

	close() {
		this.iconTargets.forEach((icon) => {
			icon.classList.remove("rotate-90");
		});
		this.bodyTargets.forEach((body) => {
			body.classList.add("hidden");
		});
		this.openValue = false;
	}

	storageKey() {
		return `record-${this.recordIdValue}-section-${this.nameValue}-open`;
	}

	// Ignores up to 3 levels of parents if they have the data-persistent-section-ignore attribute
	isIgnored(target) {
		return (
			target?.dataset?.persistentSectionIgnore ||
			target?.parentElement?.dataset?.persistentSectionIgnore ||
			target?.parentElement?.parentElement?.dataset?.persistentSectionIgnore ||
			target?.parentElement?.parentElement?.parentElement?.dataset?.persistentSectionIgnore
		);
	}
}
